var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.094,
    height: 38.792,
    viewBox: "0 0 29.094 38.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3690",
    "data-name": "Caminho 3690",
    d: "M16.971,10.3V0H1.818A1.814,1.814,0,0,0,0,1.818V36.973a1.814,1.814,0,0,0,1.818,1.818H27.275a1.814,1.814,0,0,0,1.818-1.818V12.122H18.79A1.824,1.824,0,0,1,16.971,10.3ZM4.849,5.455a.606.606,0,0,1,.606-.606h6.061a.606.606,0,0,1,.606.606V6.667a.606.606,0,0,1-.606.606H5.455a.606.606,0,0,1-.606-.606Zm0,4.849A.606.606,0,0,1,5.455,9.7h6.061a.606.606,0,0,1,.606.606v1.212a.606.606,0,0,1-.606.606H5.455a.606.606,0,0,1-.606-.606Zm14.608,18.79h3.575a1.212,1.212,0,1,1,0,2.424H19.457A3.257,3.257,0,0,1,16.53,29.71a.839.839,0,0,0-.771-.494.826.826,0,0,0-.759.469l-.581,1.162a1.211,1.211,0,0,1-1.084.67c-.029,0-.057,0-.086,0a1.208,1.208,0,0,1-1.063-.825L10.91,26.866l-.8,2.415A3.271,3.271,0,0,1,7,31.518H6.061a1.212,1.212,0,1,1,0-2.424H7a.849.849,0,0,0,.806-.58l1.378-4.14a1.819,1.819,0,0,1,3.451,0l1.052,3.155a3.4,3.4,0,0,1,5,1.073.865.865,0,0,0,.77.492ZM28.563,7.955,21.146.53A1.817,1.817,0,0,0,19.858,0H19.4V9.7h9.7V9.236A1.813,1.813,0,0,0,28.563,7.955Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.c17df41584449834bbd1985daff01f78.svg";
export { ForwardRef as ReactComponent };